import { Button } from "@progress/kendo-react-buttons";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { Input, NumericTextBox } from "@progress/kendo-react-inputs";
import { categories, emptyFilters, priorities, tags } from "../../constants";
import { localizeOptions } from "../../utils/i18n";

export default function ExpenseFilters({ filters, locale, onUpdateFilters, t = {} }) {
  const allLabel = locale?.common?.all || "All";
  const categoryOptions = [{ text: allLabel, value: "All" }, ...localizeOptions(categories, locale, "categories")];
  const priorityOptions = [{ text: allLabel, value: "All" }, ...localizeOptions(priorities, locale, "priorities")];
  const tagOptions = localizeOptions(tags, locale, "tags");
  const selectedTags = tagOptions.filter((tag) => (filters.tags || []).includes(tag.value));
  const updateFilter = (changes) => onUpdateFilters({ ...filters, ...changes });
  const periodOptions = [
    { value: "all", text: t.periodFilters?.all || "All" },
    { value: "today", text: t.periodFilters?.today || "Today" },
    { value: "week", text: t.periodFilters?.week || "Week" },
    { value: "month", text: t.periodFilters?.month || "Month" },
    { value: "year", text: t.periodFilters?.year || "Year" }
  ];

  return (
    <section className="filter-panel">
      <div className="period-filter-row" aria-label={t.periodFiltersLabel || "Period filters"}>
        {periodOptions.map((option) => (
          <Button
            key={option.value}
            className={filters.period === option.value ? "is-selected" : ""}
            fillMode={filters.period === option.value ? "solid" : "outline"}
            themeColor={filters.period === option.value ? "primary" : "base"}
            onClick={() => updateFilter({ period: option.value })}
          >
            {option.text}
          </Button>
        ))}
      </div>
      <div className="filter-grid">
        <div className="field">
          <label>{t.search || "Search"}</label>
          <Input
            placeholder={t.searchPlaceholder || "Search expenses"}
            value={filters.search}
            onChange={(event) => updateFilter({ search: event.value })}
          />
        </div>
        <div className="field">
          <label>{t.category || "Category"}</label>
          <DropDownList
            data={categoryOptions}
            textField="text"
            dataItemKey="value"
            value={categoryOptions.find((item) => item.value === filters.category)}
            onChange={(event) => updateFilter({ category: event.value.value })}
          />
        </div>
        <div className="field">
          <label>{t.priority || "Priority"}</label>
          <DropDownList
            data={priorityOptions}
            textField="text"
            dataItemKey="value"
            value={priorityOptions.find((item) => item.value === filters.priority)}
            onChange={(event) => updateFilter({ priority: event.value.value })}
          />
        </div>
        <div className="field">
          <label>{t.tags || "Tags"}</label>
          <MultiSelect
            data={tagOptions}
            textField="text"
            dataItemKey="value"
            value={selectedTags}
            onChange={(event) => updateFilter({ tags: event.value.map((tag) => tag.value) })}
          />
        </div>
        <div className="field">
          <label>{t.minAmount || "Min amount"}</label>
          <NumericTextBox value={filters.minAmount} min={0} onChange={(event) => updateFilter({ minAmount: event.value })} />
        </div>
        <div className="field">
          <label>{t.maxAmount || "Max amount"}</label>
          <NumericTextBox value={filters.maxAmount} min={0} onChange={(event) => updateFilter({ maxAmount: event.value })} />
        </div>
        <div className="field">
          <label>{t.startDate || "Start date"}</label>
          <DatePicker value={filters.startDate} onChange={(event) => updateFilter({ startDate: event.value })} />
        </div>
        <div className="field">
          <label>{t.endDate || "End date"}</label>
          <DatePicker value={filters.endDate} onChange={(event) => updateFilter({ endDate: event.value })} />
        </div>
      </div>
      <Button fillMode="flat" icon="filter-clear" onClick={() => onUpdateFilters(emptyFilters)}>
        {t.clearFilters || "Clear filters"}
      </Button>
    </section>
  );
}
